export default "__VITE_ASSET__c6c6c3cd__"